"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountrySelect = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const armoury_common_1 = require("@charterindex/armoury-common");
const Autocomplete_1 = __importDefault(require("@mui/material/Autocomplete"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const react_1 = require("react");
const OPTIONS = [null, ...armoury_common_1.COUNTRIES];
const getOptionLabel = (country) => country?.name ?? '';
const renderOption = (props, country) => (country && ((0, jsx_runtime_1.jsx)("li", { ...props, children: (0, jsx_runtime_1.jsx)(Typography_1.default, { children: country.name }) })));
const CountrySelect = ({ id, className, label, required, size, value, onChange, disabled }) => {
    const renderInput = (0, react_1.useCallback)((params) => ((0, jsx_runtime_1.jsx)(TextField_1.default, { ...params, label: label, required: required, size: size })), [label, required, size]);
    const handleChange = (0, react_1.useCallback)((ev, value) => {
        onChange?.(value);
    }, [onChange]);
    return ((0, jsx_runtime_1.jsx)(Autocomplete_1.default, { id: id, className: className, options: OPTIONS, value: value, onChange: handleChange, renderInput: renderInput, renderOption: renderOption, getOptionLabel: getOptionLabel, disabled: disabled }));
};
exports.CountrySelect = CountrySelect;
//# sourceMappingURL=country-select.js.map